import React from 'react';
import Icon from './../ui/Icon';

export default ({ message }) => (
  <div className="form-error">
    <Icon name="warning" /> {message}
  </div>
);
